import React from 'react';
import Button from '../../../components/Button/Button';
import DateInput from '../../../components/DateInput/DateInput';
import { DateField } from './ListViewDate.style';
import { todayDateObject } from '../../../libs/dateTimeUtilities';
import type { ListViewDate } from '../../types';

interface ListViewDateFieldProps {
  date: ListViewDate;
  onChange: (date: ListViewDate) => void;
}

const ListViewDateField = ({ date, onChange }: ListViewDateFieldProps) => {
  /* Read per render rather than once at module load, so a session left open
     overnight still bounds against the real today. */
  const minDate = todayDateObject().subtract(3, 'y');
  const maxDate = todayDateObject().add(10, 'y');
  const previousDay = date.clone().subtract(1, 'd');
  const nextDay = date.clone().add(1, 'd');

  return (
    <DateField>
      <Button
        contentType="icon"
        icon="navigate-before"
        disabled={previousDay.isBefore(minDate, 'day')}
        onClick={() => onChange(previousDay)}
        aria-label={i18n('Previous day')}
        dataAttributes={{ 'data-test-previous-day': true }}
      />
      <DateInput
        initialInputDateObject={date}
        onDateChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        aria-label={i18n('Date')}
        data-test-list-view-date
      />
      <Button
        contentType="icon"
        icon="navigate-next"
        disabled={nextDay.isAfter(maxDate, 'day')}
        onClick={() => onChange(nextDay)}
        aria-label={i18n('Next day')}
        dataAttributes={{ 'data-test-next-day': true }}
      />
      <Button
        size="small"
        color="default"
        variant="outlined"
        tw="h-32"
        onClick={() => onChange(todayDateObject())}
        dataAttributes={{ 'data-test-pick-today': true }}
      >
        {i18n('Pick today')}
      </Button>
    </DateField>
  );
};

export default ListViewDateField;
